<h2 class="_sansSerif _primary" [i18nKey]="'intro.generalities.title'"></h2>

<kiwi-spacer [size]="24"></kiwi-spacer>

<p [innerHTML]="'intro.generalities.paragraph.1'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.generalities.paragraph.1'}]"></p>

<div class="grid-x small-up-3 groupItems">
    <div class="cell">
        <div class="groupItems-item"[i18nKey]="'intro.generalities.element.1'"></div>
    </div>
    <div class="cell">
        <div class="groupItems-item"[i18nKey]="'intro.generalities.element.2'"></div>
    </div>
    <div class="cell">
        <div class="groupItems-item _fullHeight"[i18nKey]="'intro.generalities.element.3'"></div>
    </div>
</div>

<kiwi-spacer [size]="16"></kiwi-spacer>

<p [innerHTML]="'intro.generalities.paragraph.2'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.generalities.paragraph.2'}]"></p>

<kiwi-spacer [size]="16"></kiwi-spacer>

<p [i18nKey]="'intro.generalities.paragraph.3'"></p>

<div class="grid-x grid-margin-x">
    <fieldset class="cell small-12 introductionFieldset">
        <legend [i18nKey]="'intro.generalities.element.4'"></legend>

        <ul>
            <li [i18nKey]="'intro.generalities.element.5'"></li>
            <li [i18nKey]="'intro.generalities.element.6'"></li>
            <li [i18nKey]="'intro.generalities.element.7'"></li>
            <li [i18nKey]="'intro.generalities.element.8'"></li>
        </ul>
    </fieldset>
    <fieldset class="cell small-12 introductionFieldset">
        <legend [i18nKey]="'intro.generalities.element.9'"></legend>

        <ul>
            <li [i18nKey]="'intro.generalities.element.10'"></li>
            <li [i18nKey]="'intro.generalities.element.11'"></li>
            <li [i18nKey]="'intro.generalities.element.12'"></li>
        </ul>
    </fieldset>
</div>

<kiwi-spacer [size]="16"></kiwi-spacer>

<p [i18nKey]="'intro.generalities.paragraph.4'"></p>
<p [i18nKey]="'intro.generalities.paragraph.5'"></p>
<p>{{'intro.generalities.paragraph.initial.capital' | translate:{'initialCapital' : (initialCapital | number:'1.0')} }}</p>
<kiwi-spacer [size]="16"></kiwi-spacer>

<h3 [i18nKey]="'intro.generalities.paragraph.6'"></h3>
<kiwi-spacer [size]="4"></kiwi-spacer>
<h6 class="_primary"[i18nKey]="'intro.generalities.paragraph.7'"></h6>
<kiwi-spacer [size]="8"></kiwi-spacer>
<p [innerHTML]="'intro.generalities.paragraph.8'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.generalities.paragraph.8'}]"></p>
<kiwi-spacer [size]="16"></kiwi-spacer>

<div class="grid-x">
    <div class="graphImg cell small-24"></div>
</div>

<kiwi-spacer [size]="32"></kiwi-spacer>
<h6 class="_primary"[i18nKey]="'intro.generalities.paragraph.9'"></h6>
<kiwi-spacer [size]="8"></kiwi-spacer>
<p [innerHTML]="'intro.generalities.paragraph.10'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.generalities.paragraph.10'}]"></p>

<div class="restaurantChoice">
    <div class="restaurantChoice-item">
        <div class="restaurantChoice-item-illu _firstRestaurant"></div>
        <span class="restaurantChoice-item-name"[i18nKey]="'intro.generalities.element.13'"></span>
    </div>
    <div class="restaurantChoice-item">
        <div class="restaurantChoice-item-illu _secondRestaurant"></div>
        <span class="restaurantChoice-item-name"[i18nKey]="'intro.generalities.element.14'"></span>
    </div>
    <div class="restaurantChoice-item">
        <div class="restaurantChoice-item-illu _thirdRestaurant"></div>
        <span class="restaurantChoice-item-name"[i18nKey]="'intro.generalities.element.15'"></span>
    </div>
</div>

<p [i18nKey]="'intro.generalities.paragraph.11'"></p>
<kiwi-spacer [size]="24"></kiwi-spacer>
<h6 class="_primary"[i18nKey]="'intro.generalities.paragraph.12'"></h6>
<kiwi-spacer [size]="8"></kiwi-spacer>
<p [innerHTML]="'intro.generalities.paragraph.13'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.generalities.paragraph.13'}]">

</p><kiwi-spacer [size]="24"></kiwi-spacer>
<h3 [i18nKey]="'intro.generalities.paragraph.14'"></h3>
<kiwi-spacer [size]="8"></kiwi-spacer>
<p [innerHTML]="'intro.generalities.paragraph.15'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.generalities.paragraph.15'}]"></p>
<p [innerHTML]="'intro.generalities.paragraph.16'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.generalities.paragraph.16'}]"></p>
<p [innerHTML]="'intro.generalities.paragraph.17'|translate" [i18nKey]="[{target: 'innerHTML', key: 'intro.generalities.paragraph.17'}]"></p>

